module.exports = __webpack_public_path__ + "static/media/dashboardGrey.cfcd5d52.svg";